import { useContext, useMemo } from 'react';
import { getTamperDetectionAccess } from 'shared/lib/authUtils';
import { PermissionContext } from './PermissionProvider';

/**
 * useTamperDetectionAccess — reactive tamper detection ("Tampering Document")
 * access for the Permission Access Layer (SA-1789).
 *
 * Reads `company` from the reactive PermissionContext projection and derives the
 * flag from `tamper_setting`, which rides inside the same `company` blob that
 * `applyPermissionsFromMe` rewrites on login and on token refresh — so no new
 * watched storage key was needed. Mirrors `useFeatureAccess`.
 *
 * @returns {{ isTamperDetectionActive: boolean }}
 */
export const useTamperDetectionAccess = () => {
  const { company } = useContext(PermissionContext);

  return useMemo(
    () => getTamperDetectionAccess(company?.tamper_setting),
    [company]
  );
};
